import React, { useEffect, useState } from "react";
import DropdownInput from "./FormBuilderInputs/DropdownInput";
import UISignature from "./FormBuilderInputs/Signature";

// 1. Open (or create) a database
function openDatabase() {
	return new Promise((resolve, reject) => {
		const request = indexedDB.open("MyDatabase", 1);

		request.onupgradeneeded = (event) => {
			const db = event.target.result;
			if (!db.objectStoreNames.contains("myStore")) {
				db.createObjectStore("myStore", { keyPath: "id" });
			}
		};

		request.onsuccess = (event) => {
			resolve(event.target.result);
		};

		request.onerror = (event) => {
			reject(event.target.error);
		};
	});
}

// 2. Store data with a key
async function storeData(key, value) {
	const db = await openDatabase();

	return new Promise((resolve, reject) => {
		const transaction = db.transaction(["myStore"], "readwrite");
		const store = transaction.objectStore("myStore");
		const request = store.put({ id: key, data: value });

		request.onsuccess = () => {
			resolve();
		};

		request.onerror = () => {
			reject(request.error);
		};
	});
}

// 3. Retrieve data by key
async function getData(key) {
	const db = await openDatabase();

	return new Promise((resolve, reject) => {
		const transaction = db.transaction(["myStore"], "readonly");
		const store = transaction.objectStore("myStore");
		const request = store.get(key);

		request.onsuccess = () => {
			resolve(request.result);
		};

		request.onerror = () => {
			reject(request.error);
		};
	});
}

// 4. Get all data
async function getAllData() {
	const db = await openDatabase();

	return new Promise((resolve, reject) => {
		const transaction = db.transaction(["myStore"], "readonly");
		const store = transaction.objectStore("myStore");
		const request = store.getAll();

		request.onsuccess = () => {
			resolve(request.result);
		};

		request.onerror = () => {
			reject(request.error);
		};
	});
}

// 5. Delete data by key
async function deleteData(key) {
	const db = await openDatabase();

	return new Promise((resolve, reject) => {
		const transaction = db.transaction(["myStore"], "readwrite");
		const store = transaction.objectStore("myStore");
		const request = store.delete(key);

		request.onsuccess = () => {
			resolve();
		};

		request.onerror = () => {
			reject(request.error);
		};
	});
}

export default function Offline() {
	const [data, setData] = useState([]);
	const [formData, setFormData] = useState({
		id: "",
		name: "",
		age: "",
		img: "",
	});
	const [editMode, setEditMode] = useState(false);

	// Load all data from IndexedDB
	async function loadData() {
		const allData = await getAllData();
		setData(allData);
	}

	// Initialize with 3 sample rows
	async function initializeData() {
		const existing = await getAllData();
		if (existing.length === 0) {
			await storeData("user1", {
				name: "John",
				age: 30,
				img: "https://via.placeholder.com/150/0000FF/808080?text=User1",
			});
			await storeData("user2", {
				name: "Jane",
				age: 25,
				img: "https://via.placeholder.com/150/FF0000/FFFFFF?text=User2",
			});
			await storeData("user3", {
				name: "Bob",
				age: 35,
				img: "https://via.placeholder.com/150/00FF00/000000?text=User3",
			});
			loadData();
		}
	}

	useEffect(() => {
		initializeData();
		loadData();
	}, []);

	// Handle form input changes
	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value,
		});
	};

	// Add or Update data
	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!formData.id || !formData.name) {
			alert("ID and Name are required!");
			return;
		}

		await storeData(formData.id, {
			name: formData.name,
			age: formData.age,
			img: formData.img,
		});

		// Reset form
		setFormData({ id: "", name: "", age: "", img: "" });
		setEditMode(false);
		loadData();
	};

	// Edit data
	const handleEdit = (item) => {
		setFormData({
			id: item.id,
			name: item.data.name,
			age: item.data.age,
			img: item.data.img,
		});
		setEditMode(true);
	};

	// Delete data
	const handleDelete = async (id) => {
		if (window.confirm("Are you sure you want to delete this item?")) {
			await deleteData(id);
			loadData();
		}
	};

	// Cancel edit
	const handleCancel = () => {
		setFormData({ id: "", name: "", age: "", img: "" });
		setEditMode(false);
	};
	const [show, setShow] = useState(false);
	return (
		<div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
			<h1>IndexedDB CRUD Example</h1>

			{/* Add/Edit Form */}
			<div
				style={{
					border: "1px solid #ccc",
					padding: "20px",
					marginBottom: "20px",
					borderRadius: "5px",
				}}
			>
				<h2>{editMode ? "Edit Item" : "Add New Item"}</h2>
				<form onSubmit={handleSubmit}>
					<div style={{ marginBottom: "10px" }}>
						<label>
							ID:{" "}
							<input
								type="text"
								name="id"
								value={formData.id}
								onChange={handleChange}
								disabled={editMode}
								style={{ marginLeft: "10px", padding: "5px" }}
							/>
						</label>
					</div>
					<div style={{ marginBottom: "10px" }}>
						<label>
							Name:{" "}
							<input
								type="text"
								name="name"
								value={formData.name}
								onChange={handleChange}
								style={{ marginLeft: "10px", padding: "5px" }}
							/>
						</label>
					</div>
					<div style={{ marginBottom: "10px" }}>
						<label>
							Age:{" "}
							<input
								type="number"
								name="age"
								value={formData.age}
								onChange={handleChange}
								style={{ marginLeft: "10px", padding: "5px" }}
							/>
						</label>
					</div>
					<div style={{ marginBottom: "10px" }}>
						<label>
							Image URL:{" "}
							<input
								type="text"
								name="img"
								value={formData.img}
								onChange={handleChange}
								style={{ marginLeft: "10px", padding: "5px", width: "300px" }}
							/>
						</label>
					</div>
					<button
						type="submit"
						style={{
							padding: "10px 20px",
							backgroundColor: "#4CAF50",
							color: "white",
							border: "none",
							borderRadius: "3px",
							cursor: "pointer",
							marginRight: "10px",
						}}
					>
						{editMode ? "Update" : "Add"}
					</button>
					{editMode && (
						<button
							type="button"
							onClick={handleCancel}
							style={{
								padding: "10px 20px",
								backgroundColor: "#999",
								color: "white",
								border: "none",
								borderRadius: "3px",
								cursor: "pointer",
							}}
						>
							Cancel
						</button>
					)}
				</form>
			</div>

			{/* Display Data */}
			<h2>Stored Data</h2>
			<div
				style={{
					display: "grid",
					gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
					gap: "20px",
				}}
			>
				{data.map((item) => (
					<div
						key={item.id}
						style={{
							border: "1px solid #ddd",
							padding: "15px",
							borderRadius: "5px",
							backgroundColor: "#f9f9f9",
						}}
					>
						{item.data.img && (
							<img
								src={item.data.img}
								alt={item.data.name}
								style={{
									width: "100%",
									height: "150px",
									objectFit: "cover",
									borderRadius: "5px",
									marginBottom: "10px",
								}}
							/>
						)}
						<h3 style={{ margin: "5px 0" }}>{item.data.name}</h3>
						<p style={{ margin: "5px 0" }}>Age: {item.data.age}</p>
						<p style={{ margin: "5px 0", fontSize: "12px", color: "#666" }}>
							ID: {item.id}
						</p>
						<div style={{ marginTop: "10px" }}>
							<button
								onClick={() => handleEdit(item)}
								style={{
									padding: "5px 10px",
									backgroundColor: "#2196F3",
									color: "white",
									border: "none",
									borderRadius: "3px",
									cursor: "pointer",
									marginRight: "5px",
								}}
							>
								Edit
							</button>
							<button
								onClick={() => handleDelete(item.id)}
								style={{
									padding: "5px 10px",
									backgroundColor: "#f44336",
									color: "white",
									border: "none",
									borderRadius: "3px",
									cursor: "pointer",
								}}
							>
								Delete
							</button>
						</div>
					</div>
				))}
			</div>
			<button onClick={() => setShow(true)}>Show Dropdown & signature</button>
			{show && (
				<>
					<DropdownInput />
					<UISignature />
				</>
			)}
		</div>
	);
}
